import { IFormatter } from '../FormatterTypes';
import { TEDValidateDefault } from '../Validators/TEDValidateDefault';
import { TEDDisplayGroupedNr } from '../Displayers/TEDDisplayGroupedNr';
import { TEDParseGroupedNr } from '../Parsers/TEDParseGroupedNr';

class TEDFormatGroupedNr implements IFormatter {
  displayer = TEDDisplayGroupedNr.getInstance();
  parser = TEDParseGroupedNr.getInstance();
  validator = TEDValidateDefault.getInstance();
}

export { TEDFormatGroupedNr };
